import { useState } from 'react';
import DateRangeCalendar from './DateRangeCalendar';
import Modal from './Modal';
import './DatePickerField.css';

export default function DatePickerField({ value, onChange, label, required = false, name, placeholder = 'Выберите дату' }) {
  const [isOpen, setIsOpen] = useState(false);

  const formatDate = (iso) => {
    if (!iso) return '';
    return new Date(iso).toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).replace(' г.', '');
  };

  const handleSelect = (dateStr) => {
    onChange(dateStr);
    setIsOpen(false);
  };

  return (
    <div className="datepicker-field">
      {label && (
        <label style={{ 
          fontSize: '11px', 
          color: 'var(--text-secondary)', 
          fontWeight: 600, 
          textTransform: 'uppercase', 
          letterSpacing: '0.5px', 
          marginBottom: '6px', 
          display: 'block' 
        }}>
          {label}{required && ' *'}
        </label>
      )}
      <input type="hidden" name={name} value={value || ''} />
      <div 
        className="datepicker-input" 
        onClick={() => setIsOpen(true)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          background: 'var(--surface-color)',
          border: '1px solid var(--border-color)',
          borderRadius: '8px',
          padding: '10px 14px',
          color: 'var(--text-primary)',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          fontSize: '14px',
          height: '40px',
          boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.02)'
        }}
      >
        <span className="datepicker-icon" style={{ fontSize: '16px', display: 'inline-flex' }}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg></span>
        <span style={{ fontWeight: value ? '600' : '400', color: value ? 'var(--text-primary)' : 'var(--text-tertiary)' }}>
          {value ? formatDate(value) : placeholder}
        </span>
      </div>
      
      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={label || "Выберите дату"}
        isBottomSheet={true}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '10px 0 20px 0' }}>
          <DateRangeCalendar 
            startDate={value} 
            endDate={value} 
            onDateSelect={handleSelect} 
          />
          <div style={{ display: 'flex', gap: '12px', marginTop: '12px' }}>
            <button 
              type="button" 
              className="btn btn-ghost" 
              style={{ flex: 1, padding: '12px', background: 'var(--bg-secondary)', fontWeight: 600 }} 
              onClick={() => {
                onChange('');
                setIsOpen(false);
              }}
            >
              Сбросить
            </button>
            <button 
              type="button" 
              className="btn btn-primary" 
              style={{ flex: 2, padding: '12px', fontWeight: 600 }} 
              onClick={() => setIsOpen(false)}
            >
              Готово
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
